// D-0121 (Rafael 27/10): linha com valor e sem Sub Item não salva, e o grupo 3028 - FEE não entra
// quando o orçamento já tem o 130 - FEE.
//
// Por quê: a linha sem Sub Item soma no total, mas fica fora da base do FEE (o cálculo só conhece a
// linha pelo item do catálogo). No #903 (AbbVie Mini Meeting) a hospedagem sem Sub Item deixou a base
// zerada e o FEE em 0. O 3028 - FEE aparece com o mesmo título "FEE" do 130: a operadora digitava o FEE
// nele e, ao tirar o grupo, o FEE sumia.
//
// Vale para linha NOVA (sem id), com valor mudado na tela, com o item trocado ou que mudou de grupo, e
// para o grupo 3028 novo ou trocado na tela. Linha ou grupo antigo parado só gera aviso (não trava),
// como na observação obrigatória. Espelho da API: App\Services\OrcamentoSubItemObrigatorio.

import { AgenciaOrcamentoPolicy } from './agenciaOrcamentoPolicy';

export const ID_GRUPO_FEE_3028 = '413558481789443599';
export const ETAPAS_VALOR = ['PreEvento', 'Negociado', 'Fechamento'];
const CAMPOS_VALOR = ['quantidade', 'diaria', 'valorUnitario', 'servico'];

const idDe = (valor) => String(valor && typeof valor === 'object' ? (valor.id ?? '') : (valor ?? '')).trim();
const numero = (valor) => {
    const n = Number(valor);
    return Number.isFinite(n) ? n : 0;
};

export function ehGrupoFee3028(grupo = {}) {
    const produto = grupo?.produto ?? {};
    return idDe(produto) === ID_GRUPO_FEE_3028 || String(produto?.codigo ?? '').trim() === '3028';
}

export function temGrupoFee130(orcamento = {}) {
    return (orcamento?.orcamentoitem || []).some((grupo) => grupo && AgenciaOrcamentoPolicy.isGrupoAgencia(grupo));
}

// Valores que decidem se a linha foi alterada na tela (mesma assinatura da API).
export function assinaturaValores(subitem = {}) {
    return ETAPAS_VALOR.map((etapa) => CAMPOS_VALOR.map((campo) => numero(subitem?.[campo + etapa]).toFixed(4)).join('|')).join('/');
}

export function linhaTemValor(subitem = {}) {
    return ETAPAS_VALOR.some((etapa) => Math.abs(
        numero(subitem?.['quantidade' + etapa]) * numero(subitem?.['diaria' + etapa]) * numero(subitem?.['valorUnitario' + etapa])
    ) > 0.004);
}

// Foto tirada ao carregar: { linhas: { id: { valores, grupo } }, grupos: { id: produtoId } }.
export function fotografarGravado(orcamento = {}) {
    const foto = { linhas: {}, grupos: {} };
    (orcamento?.orcamentoitem || []).forEach((grupo) => {
        if (!grupo) return;
        if (grupo.id) foto.grupos[idDe(grupo.id)] = idDe(grupo.produto);
        (grupo.subitem || []).forEach((subitem) => {
            if (subitem?.id) foto.linhas[idDe(subitem.id)] = { valores: assinaturaValores(subitem), grupo: idDe(grupo.id) };
        });
    });
    return foto;
}

function linhaAlterada(subitem, grupo, foto) {
    if (!subitem?.id || subitem?.produtoTrocadoNaTela === true) return true;
    const gravada = foto?.linhas?.[idDe(subitem.id)];
    if (!gravada) return true;
    return gravada.valores !== assinaturaValores(subitem) || gravada.grupo !== idDe(grupo?.id);
}

function grupoNovoOuTrocado(grupo, foto) {
    if (!grupo?.id) return true;
    const gravado = foto?.grupos?.[idDe(grupo.id)];
    return gravado === undefined || gravado !== idDe(grupo.produto);
}

const nomeGrupo = (grupo) => AgenciaOrcamentoPolicy.nomeGrupoExibicao(grupo?.produto ?? {}, true) || 'grupo sem nome';

// { bloqueiam: [...], avisos: [...] } no formato do alerta do rodapé (AlertaDadosInternacionais).
export function listarPendenciasSubItem(orcamento = {}, foto = null) {
    const bloqueiam = [];
    const avisos = [];
    const tem130 = temGrupoFee130(orcamento);
    (orcamento?.orcamentoitem || []).forEach((grupo, grupoIndex) => {
        if (!grupo) return;
        if (tem130 && ehGrupoFee3028(grupo)) {
            const novo = grupoNovoOuTrocado(grupo, foto);
            (novo ? bloqueiam : avisos).push({
                tipo: 'grupo_fee',
                mensagem: novo
                    ? 'Grupo 3028 - FEE: remova este grupo. O FEE do orçamento é o do grupo 130 - FEE.'
                    : 'Grupo 3028 - FEE: o FEE do orçamento é o do grupo 130 - FEE. Confira se este grupo não cobra o FEE em dobro.',
                alvo: { grupoIndex, linhaIndex: 0 },
            });
        }
        (grupo.subitem || []).forEach((subitem, linhaIndex) => {
            if (!subitem || idDe(subitem.produto) !== '' || !linhaTemValor(subitem)) return;
            const trava = linhaAlterada(subitem, grupo, foto);
            (trava ? bloqueiam : avisos).push({
                tipo: 'sub_item',
                mensagem: trava
                    ? `${nomeGrupo(grupo)}, linha ${linhaIndex + 1}: escolha o Sub Item. Linha sem Sub Item fica fora do FEE.`
                    : `${nomeGrupo(grupo)}, linha ${linhaIndex + 1}: sem Sub Item, esta linha fica fora do FEE.`,
                alvo: { grupoIndex, linhaIndex, campo: 'sub_item' },
            });
        });
    });
    return { bloqueiam, avisos };
}

// Opção do seletor de grupo: o 3028 - FEE fica desabilitado quando o orçamento já tem o 130 - FEE.
export function grupoFeeDesabilitado(opcao = {}, orcamento = {}) {
    return temGrupoFee130(orcamento) && ehGrupoFee3028({ produto: { id: opcao?.value, codigo: opcao?.codigo } });
}
